/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from "@/hooks/use-toast";
import { getJobId } from "@/lib/utils";
import { apiServices } from "@/services/api.services";
import {
  documentsDetails,
  jobId,
  runErpReprocess,
} from "@/services/global.services";
import { useState } from "react";

export const useReprocessErp = ({
  company_id,
  user_id,
  setGlobalLoading,
}: any) => {
  const [process, setProcess] = useState(false);
  const loadingDetailsData = async (doc_id: string) => {
    const payload = {
      data: {
        doc_id: doc_id,
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      documentsDetails.get,
      "post",
      payload
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data: data?.result?.metadata?.domain, error };
  };

  const onErpReprocess = async (formData: any): Promise<any> => {
    // setProcess(true);

    const payload = {
      data: {
        doc_id: formData.doc_id,
        domain_id: formData.domain_id,
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      runErpReprocess.post,
      "post",
      payload
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  // const getJobId = async (prop: string, isInProgressExist?: boolean) => {
  //   while (true) {
  //     const { data, error, message } = await apiServices<any>(
  //       jobId.get + prop,
  //       "get"
  //     );

  //     if (data?.process_status !== "in-progress" || isInProgressExist) {
  //       if (data?.error) {
  //         toast({
  //           title: "Error",
  //           variant: "destructive",
  //           description: error.status?.message || message,
  //         });
  //       }

  //       if (data?.status?.error_details?.fail_message) {
  //         toast({
  //           title: "Error",
  //           variant: "destructive",
  //           description: data.status.error_details.fail_message,
  //         });
  //         return { data: null, error: data.status.error_details.fail_message };
  //       }

  //       return { data, error };
  //     }

  //     await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait for 5 seconds before next call
  //   }
  // };

  const reprocessCurrentErp = async (prop: any) => {
    const doc_id = prop.doc_id;
    setProcess(true);
    setGlobalLoading(true);
    const getDomain = await loadingDetailsData(doc_id);
    if (getDomain.data) {
      const erpReprocess = await onErpReprocess({
        doc_id: doc_id,
        domain_id: getDomain.data?.domain_id,
      });
      console.log("erpReprocess", erpReprocess);
      if (erpReprocess?.error) {
        setProcess(false);
      }
      if (erpReprocess.data.job_id) {
        const jobIdReprocess = await getJobId(erpReprocess.data.job_id);
        console.log("jobIdReprocess", jobIdReprocess);
      }
    }
    setProcess(false);
    setGlobalLoading(false);
  };
  return { process, reprocessCurrentErp };
};
